var _path, _path2, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _path3, _path4, _path5, _path6, _path7, _rect9, _path8, _path9, _path10, _path11, _path12;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIllRegistrationSuccessstyled(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, ["title", "titleId"]);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 343,
    height: 343,
    viewBox: "0 0 343 343",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M107.375 277.964C70.2152 248.851 -6.11042 162.949 96.3241 114.759C178.836 75.941 183.042 21.7229 247.725 60.1555C284.96 82.2797 329.784 169.861 267.228 252.903C213.883 323.717 131.893 297.172 107.375 277.964Z",
    fill: "var(--color-theme_clubNavigation1, var(--color-theme_clubNavigation1-override, rgba(51,51,51,1)))",
    fillOpacity: 0.1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M236.249 184.698C236.249 182.231 235.648 179.886 234.579 177.822C237.864 175.079 239.973 170.95 239.973 166.338C239.973 158.085 233.257 151.369 225.004 151.369H189.691V127.246C189.691 114.418 179.27 103.997 166.442 103.997C163.247 103.997 160.663 106.581 160.663 109.776C160.663 120.726 160.114 130.907 157.846 138.543C155.933 144.984 153.012 149.014 148.645 150.587C146.593 145.763 141.822 142.365 136.243 142.365H121.459C114.022 142.365 107.973 148.414 107.973 155.851V231.904C107.973 239.341 114.022 245.39 121.459 245.39H136.243C142.117 245.39 147.107 241.619 148.956 236.386H213.87C222.122 236.386 228.838 229.67 228.838 221.417C228.838 218.951 228.237 216.606 227.168 214.542C230.453 211.799 232.562 207.67 232.562 203.057C232.562 200.589 231.96 198.242 230.889 196.176C234.158 193.436 236.249 189.317 236.249 184.698Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 6
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 119,
    y: 152,
    width: 24,
    height: 86,
    rx: 5,
    fill: "var(--color-theme_clubPrimaryLight, var(--color-theme_clubPrimaryLight-override, rgba(172,110,231,1)))"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.1,
    x: 143,
    y: 221,
    width: 74,
    height: 8,
    rx: 4,
    fill: "black"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.1,
    x: 212,
    y: 202,
    width: 10,
    height: 8,
    rx: 4,
    fill: "black"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.1,
    x: 215,
    y: 184,
    width: 10,
    height: 8,
    rx: 4,
    fill: "black"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.1,
    x: 219,
    y: 166,
    width: 10,
    height: 8,
    rx: 4,
    fill: "black"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.1,
    x: 176,
    y: 148,
    width: 8,
    height: 8,
    rx: 4,
    fill: "black"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.1,
    x: 115,
    y: 229,
    width: 21,
    height: 8,
    rx: 4,
    fill: "black"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 119,
    y: 161,
    width: 24,
    height: 7,
    fill: "white",
    fillOpacity: 0.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M176.5 155C190.667 155 219.6 155 224 155C229.5 155 233 159.5 233 164C233 168.5 230.5 173.5 224.5 173.5C223 173.5 221.5 173.5 220.5 173.5",
    stroke: "black",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M220.5 173.5C226 173.5 229.5 178 229.5 182.5C229.5 187 227 192 221 192C219.5 192 218 192 217 192",
    stroke: "black",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M216.64 192C222.36 192 226 196.378 226 200.757C226 205.135 223.4 210 217.16 210C215.6 210 214.04 210 213 210",
    stroke: "black",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M213.36 210C218.64 210 222 214.5 222 219C222 223.5 218.5 228.5 212.5 228.5C211.06 228.5 144.96 228.5 144 228.5",
    stroke: "black",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M183 155C183 155 183 138 183 126C183 114 173.1 107.5 165.5 107.5C165.5 118 165 125.5 163.5 133C161.6 142.5 157 155 144 155",
    stroke: "black",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 113,
    y: 146,
    width: 30,
    height: 92,
    rx: 9,
    stroke: "black",
    strokeWidth: 4
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M215 115.5H238.5",
    stroke: "var(--color-theme_clubPrimaryLight, var(--color-theme_clubPrimaryLight-override, rgba(172,110,231,1)))",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M106 115.5H129.5",
    stroke: "var(--color-theme_clubPrimaryLight, var(--color-theme_clubPrimaryLight-override, rgba(172,110,231,1)))",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M125 68L141.617 84.617",
    stroke: "var(--color-theme_clubPrimaryLight, var(--color-theme_clubPrimaryLight-override, rgba(172,110,231,1)))",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M219.617 68L203 84.617",
    stroke: "var(--color-theme_clubPrimaryLight, var(--color-theme_clubPrimaryLight-override, rgba(172,110,231,1)))",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M172.5 49L172.5 72.5",
    stroke: "var(--color-theme_clubPrimaryLight, var(--color-theme_clubPrimaryLight-override, rgba(172,110,231,1)))",
    strokeWidth: 4,
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllRegistrationSuccessstyled);
export default __webpack_public_path__ + "static/media/ill-registration-success.styled.f7523c6e.svg";
export { ForwardRef as ReactComponent };